// extracted by mini-css-extract-plugin
export default {"likesContainer":"CustomerSurvey_likesContainer__XySiD","smilesContainer":"CustomerSurvey_smilesContainer__sXpnD","footerLabel":"CustomerSurvey_footerLabel__r0aNF"};